import WebsiteTypeFilter from "../../components/filters/WebsiteTypeFilter/WebsiteTypeFilter";
import WebsiteTypeFilterResult from "../../components/filters/WebsiteTypeFilter/WebsiteTypeFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindWebsiteTypeFilter from "./WebsiteTypeFilter";

export const websiteTypeDefinition = defineDescriptionFilter({
    key: "websiteType",
    apiCategory: leadsFilterApiCategory.websiteType,
    category: leadsFilterCategoryMap.website,
    trackingName: "type",
    titleKey: { key: "si.lead_gen_filters.group.websiteType.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.websiteType.tooltip" },
        filter: new FindWebsiteTypeFilter({
            options: description.websiteType.types,
        }),
        filterView: WebsiteTypeFilter,
        filterResultView: WebsiteTypeFilterResult,
    }),
});
